import React from 'react';

import { Box, Typography } from '@mui/material';

import type { AnalysisDateProperties } from './AnalysisDate.types';

/**
 * Отображение даты анализа
 */
export const AnalysisDate: React.FC<AnalysisDateProperties> = ({
  date,
  sx,
  dataTest = 'analysis_date',
}) => {
  return (
    <Box sx={sx} data-testid={dataTest}>
      <Typography
        variant='overline'
        data-testid={`${dataTest}_label`}
        sx={{
          color: 'text.secondary',
          fontWeight: 700,
          letterSpacing: 1,
          fontSize: '0.8rem',
        }}
      >
        Дата анализа
      </Typography>
      <Typography
        variant='body1'
        data-testid={`${dataTest}_value`}
        sx={{
          mt: { xs: 0.5, md: 1 },
          fontSize: { xs: '1rem', md: '1.125rem' },
          fontWeight: 500,
          color: 'text.primary',
        }}
      >
        {date}
      </Typography>
    </Box>
  );
};
